import keycloakConfig from "./ssokc.config";

export const environment = {
    production: true,
    apiURL: '/api',
    authProvider: 'ssokc',
    ssokc: keycloakConfig,
    echoKey: 'mbqRJA.RtXpCw'
};
